/* "Merged from another device" (owner request 2026-10-30): when the database fitted a change from this device together
   with changes made on the person's other devices (migration 016: in the order they were really made), the person is
   TOLD, never asked: a short toast at once, and a small line on the Timer and Entries screens ("↔ Merged from another
   device … Details · OK") until they tap OK. Details lists everything in plain words. Kept on this device per login
   (localStorage, the last 20), so a reload does not lose it. */
import {State, byId} from '../state.ts';
import {noteText, type MergeNote, type NoteFmt} from '../lib/merge.ts';
import {myToday, myWall, zoneName} from '../zone.ts';
import {escapeHtml, openModal, closeModal, toast, $} from './common.ts';

interface Shown { at: string; text: string }
const KEY = () => 'ot_merged_' + (localStorage.getItem('ot_last_user') || '');
function read(): Shown[] { try { return JSON.parse(localStorage.getItem(KEY()) || '[]'); } catch { return []; } }
function write(list: Shown[]) { try { list.length ? localStorage.setItem(KEY(), JSON.stringify(list.slice(-20))) : localStorage.removeItem(KEY()); } catch { /* private mode */ } }

const MONTH = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
/** "3:24:59 PM" in the person's zone (seconds only when not :00); another day gets its date */
function clock(iso: string): string {
  const ms = Date.parse(iso); if (!isFinite(ms)) return '?';
  const w = myWall(ms), h = +w.slice(11, 13), s = w.slice(17, 19);
  const t = (h % 12 || 12) + ':' + w.slice(14, 16) + (s !== '00' ? ':' + s : '') + (h < 12 ? ' AM' : ' PM');
  return w.slice(0, 10) === myToday() ? t : `${MONTH[+w.slice(5, 7) - 1]} ${+w.slice(8, 10)}, ${t}`;
}
export const fmt: NoteFmt = {clock, project: id => byId(State.projects, id)?.name || ''};

/** the database merged a change from this device: say what it did */
export function merged(notes: MergeNote[]) {
  const texts = notes.map(n => noteText(n, fmt));
  if (!texts.length) return;
  write([...read(), ...texts.map(text => ({at: new Date().toISOString(), text}))]);
  toast('Merged from another device: ' + texts[0] + (texts.length > 1 ? ` (+${texts.length - 1} more: Details)` : ''), 9000);
}
export function mergedBanner(): string {
  const list = read(); if (!list.length) return '';
  const last = list[list.length - 1];
  return `<div class="mg-bar" id="mgBar" role="status"><span class="mg-text"><strong>↔ Merged from another device</strong> · ${escapeHtml(last.text)}${list.length > 1 ? ` <span class="muted-text">(+${list.length - 1} more)</span>` : ''}</span>
    <span class="mg-acts"><button type="button" class="btn ghost" id="mgDetails">Details</button><button type="button" class="btn" id="mgOk">OK</button></span></div>`;
}
export function wireMergedBanner(render: () => void) {
  const ok = document.getElementById('mgOk'); if (ok) ok.onclick = () => { write([]); render(); };
  const d = document.getElementById('mgDetails'); if (d) d.onclick = () => openDetails(render);
}
function openDetails(render: () => void) {
  const list = read();
  openModal(`<h3>Merged from another device</h3>
    <p class="muted-text">Changes from your devices are put together in the order they were really made (${escapeHtml(zoneName())}). Nothing was counted twice and no time was lost; this is what was fitted together:</p>
    <ul class="mg-list">${list.slice().reverse().map(x => `<li>${escapeHtml(x.text)} <span class="muted-text">(${escapeHtml(clock(x.at))})</span></li>`).join('')}</ul>
    <div class="row" style="justify-content:flex-end; gap:6px; margin-top:10px;"><button type="button" class="btn ghost" id="mgClose">Close</button><button type="button" class="btn primary" id="mgClear">OK, got it</button></div>`);
  $('mgClose').onclick = closeModal;
  $('mgClear').onclick = () => { write([]); closeModal(); render(); };
}
